import { defineStore } from 'pinia'
import AuthService from '@/services/AuthService'
import localPermissions from '@/constants/localPermissions'

export const useAuthStore = defineStore('auth', {
  state: () => {
    const currentCollaborator = JSON.parse(localStorage.getItem('currentCollaborator'))
    const filtersHistoryLocal = JSON.parse(localStorage.getItem('filtersHistory'))
    const userDetailLocalStorage = JSON.parse(localStorage.getItem('userDetail'))

    return {
      auth: currentCollaborator ? { status: { loggedIn: true } } : { status: { loggedIn: false } },
      userDetail: userDetailLocalStorage ? userDetailLocalStorage : {},
      currentCollaborator: currentCollaborator,
      filtersHistory: filtersHistoryLocal
        ? filtersHistoryLocal
        : { repairFileList: { status: false } },
      repairFile: { StoreSelected: null }
    }
  },
  getters: {
    hasPermission: (state) => (permissionsRequired) => {
      if (!state.userDetail || !state.userDetail.permissions) {
        return false
      }
      const permissionSet = new Set(state.userDetail.permissions.map((p) => p.title))
      return permissionsRequired.some(
        (permission) =>
          localPermissions[permission] && permissionSet.has(localPermissions[permission].title)
      )
    },
    getCurrentCollaborator(state) {
      return state.currentCollaborator
    },
    getCollaboratorList(state) {
      if (!state.userDetail || !state.userDetail.collaborators) {
        return []
      }
      return state.userDetail.collaborators
    },
    getAccountRole(state) {
      return (state.userDetail.roles && state.userDetail.roles[0]) || {}
    },
    getRepairFileListFilters(state) {
      return state.filtersHistory.repairFileList
    }
  },
  actions: {
    async loginValidation(userData) {
      try {
        return await AuthService.loginValidation(userData)
      } catch (error) {
        this.logout()
        throw error
      }
    },
    async loginFinalization(userData) {
      try {
        await AuthService.loginFinalization(userData)
        await this.me()
        this.loginSuccess()
      } catch (error) {
        this.logout()
        throw error
      }
    },
    async verifyLogin2faCode(code) {
      await AuthService.verifyLogin2faCode(code)
    },
    async resendLogin2faCode() {
      await AuthService.resendLogin2faCode()
    },
    async me() {
      const connectedUserDetail = await AuthService.me()
      this.meSuccess(connectedUserDetail)
    },
    async logoutAction() {
      await AuthService.logout()
      this.logout()
    },
    async cleanSession() {
      await AuthService.logout()
      this.logout()
    },
    loginSuccess() {
      this.auth.status.loggedIn = true
    },
    meSuccess(connectedUserDetail) {
      this.userDetail = connectedUserDetail
      localStorage.setItem('userDetail', JSON.stringify(connectedUserDetail))
    },
    updateProfile(data) {
      this.userDetail = {
        ...this.userDetail,
        phone_number: data.phone_number
      }
      localStorage.setItem('userDetail', JSON.stringify(this.userDetail))
    },
    logout() {
      this.auth.status.loggedIn = false
      this.userDetail = {}
      this.currentCollaborator = {}
      localStorage.removeItem('userDetail')
      localStorage.removeItem('currentCollaborator')
    },
    updateCollaborator(data) {
      if (this.userDetail && this.userDetail.collaborators) {
        const index = this.userDetail.collaborators.findIndex((c) => c.technical_id === data.id)
        if (index !== -1) {
          this.userDetail.collaborators[index] = {
            ...this.userDetail.collaborators[index],
            ...data
          }
        }
      }
    },
    selectedCollaborator(newCurrentCollaboratorId) {
      if (this.userDetail && this.userDetail.collaborators) {
        const newCurrent = this.userDetail.collaborators.find(
          (item) => item.technical_id === newCurrentCollaboratorId
        )
        this.currentCollaborator = newCurrent
        localStorage.setItem('currentCollaborator', JSON.stringify(newCurrent))
      }
    },
    updateRepairFileListFilters(repairFileFilters) {
      this.filtersHistory.repairFileList = repairFileFilters
      localStorage.setItem('filtersHistory', JSON.stringify(this.filtersHistory))
    }
  }
})
